import React, { useEffect, useState } from "react";
import "./styles.css";
import Breadcrumb from "../../Elements/Breadcrumb";
import patientProfile from "../../../Assets/Images/patient-profile-img.png";
import editIcon from "../../../Assets/Icons/Edit.png";
import star from "../../../Assets/Icons/star-yellow.png";
import chatIcon from "../../../Assets/Icons/chat.png";
import MessageSection from "../../Elements/MessageSection/index";
import SideMenu from "../../Elements/SideMenu";
import RightSectionCommon from "../../Elements/RightSectionCommon";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { usePatientContext } from "../../../Context/PatientContext";
import { getPatientById, getPatientMessages } from "../../../Services";
import { getAge, getGenderCode } from "../../../Helpers";
import PatientInfo from "../../Elements/PatientInfo";

const PatientMessage = () => {
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();

  const {
    patientDetails,
    patientTimeline,
    updatePatientDetails,
    updatePatientTimeline,
  } = usePatientContext();

  const [messages, setMessages] = useState([]);

  // const handleViewAllClick = () => {
  //   setViewAllClicked(true);
  //   setIsPatientVisitRecordVisible(false);

  //   if (!viewAllClicked) {
  //     setBreadcrumbContent([
  //       { name: "Dashboard", url: "/dashboard" },
  //       { name: "Patient Visit Management" },
  //     ]);
  //   }
  // };

  const getPatientDetails = async () => {
    try {
      const detailsResponse = await getPatientById(
        physician.physician._id,
        patientId
      );
      updatePatientDetails(detailsResponse.data);
      const messagesResponse = await getPatientMessages(
        physician.physician._id,
        patientId
      );
      if (!messagesResponse.error) setMessages(messagesResponse.data.messages);
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  const updateMessagesArray = (newMessage) => {
    setMessages([...messages, newMessage]);
  };

  useEffect(() => {
    getPatientDetails();
  }, []);

  return (
    <div className="container">
      <SideMenu />
      <div className="left-section">
        <div className="patient-message">
          <Breadcrumb
            contents={[
              { name: "Dashboard", url: "/dashboard" },
              { name: "Messages", url: "/dashboard/messages" },
              {
                name: `${patientDetails.firstName} ${patientDetails.lastName}`,
              },
            ]}
          />
          <PatientInfo screen="messages" />
          <MessageSection
            messages={messages}
            patientDetails={patientDetails}
            handleNewMessage={updateMessagesArray}
          />
        </div>
      </div>
      <div id="right-section">
        <RightSectionCommon />
        {/* <div className="right-section-bottom">
          <ChatSection />
        </div> */}
      </div>
    </div>
  );
};

export default PatientMessage;
